// extracted by mini-css-extract-plugin
export default {"internalName":"style_internalName__egpic"};